import { useState } from 'react';
import type { Nullable } from 'corgi-types';

import { EventBusEvent } from '../../../enums/EventBus';
import { useSubscriptionCallback } from '../../../hooks/subscription';
import { useLocalization } from '../../../providers/LocaleProvider';
import type { ErrorMessage } from '../../../types/error';
import { getErrorMessageTranslator } from '../../../utils/error-handlers/error-message';
import { getInitialError } from '../utils/initial-error';
import useEmitCheckoutErrorMessage from './use-emit-translated-checkout-error';

const useTranslateAlertState = () => {
  const { t } = useLocalization();
  const translateErrorMessage = getErrorMessageTranslator(t);

  return (alertState: Nullable<ErrorMessage>) =>
    alertState
      ? {
          message: translateErrorMessage(alertState),
          timestamp: alertState.timestamp,
        }
      : { message: null, timestamp: 0 };
};

export const useCheckoutErrorMessage = (initialErrorDetail: Nullable<string>) => {
  const translateErrorMessage = useTranslateAlertState();
  const [{ message, timestamp, isInitialError }, setCheckoutErrorMessage] = useState(() => ({
    ...translateErrorMessage(getInitialError(initialErrorDetail)),
    isInitialError: true,
  }));

  useSubscriptionCallback<Nullable<ErrorMessage>>(EventBusEvent.ToggleCheckoutAlert, errorMessage =>
    setCheckoutErrorMessage({
      ...translateErrorMessage(errorMessage),
      isInitialError: false,
    })
  );
  useEmitCheckoutErrorMessage(message);

  return { message, timestamp, isInitialError };
};
